export default "__VITE_ASSET__293332d5__"